import React from 'react';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import Loading from '@/components/shared/Loading';
import LaunchPadView from '@/components/explore/LaunchPadView';
import NormeiTable from './NormeiTable';
import DFiltersController from '../filters/DFiltersController';
import FilterMemeMode from '../filters/FilterMemeMode';
import { useSearchHome } from '@/contexts/SearchHomeProvider';
import { DefaultStages } from '@shared/types/frontend';
import FilterByTokenType from '../filters/FilterByTokenType';
import TopTokensResults from './TopTokensResults';
import DTCashResults from './DTCashResults';
import classNames from '@/lib/misc/classNames';
import { Switch } from '@/components/ui/switch';
import Image from 'next/image';
const NormeiController = () => {
  const {
    setKeyword,
    network,
    setNetwork,
    timeFrame,
    setTimeFrame,
    defaultNetwork,
    subMode,
    setSubMode,
    subMemeData,
    resultsToUse,
    useUnprotectedSearch,
    setUseUnprotectedSearch,
    mode,
    setMode,
    stage,
    allTokens,
    allTokensLoading
  } = useSearchHome();
  return <div className='grid gap-4 h-[87vh] genius-shadow rounded-[20px] no-scrollbar' data-sentry-component="NormeiController" data-sentry-source-file="NormeiController.tsx">
      <div className='bg-genius-indigo rounded-[20px] py-2 border border-genius-blue overflow-hidden'>
        <div className='flex justify-between px-2 my-2'>
          <FilterByTokenType setKeyword={setKeyword} mode={mode} setMode={setMode} customHandler data-sentry-element="FilterByTokenType" data-sentry-source-file="NormeiController.tsx" />
          <div className='items-center flex'>
            <DFiltersController network={network} defaultNetwork={defaultNetwork} setNetwork={setNetwork} timeFrame={timeFrame} setTimeFrame={setTimeFrame} customHandler data-sentry-element="DFiltersController" data-sentry-source-file="NormeiController.tsx" />
          </div>
        </div>
        <div className='mt-2  h-full'>
          {mode === 'cash' ? <DTCashResults onTokenClick={undefined} /> : mode == 'launchpad' ? <LaunchPadView /> : <>
              {mode === 'memes' && <>
                  <FilterMemeMode setMode={setMode} subMode={subMode} setSubMode={setSubMode} timeFrame={timeFrame} subMemeData={subMemeData} network={network} />
                </>}
              {(mode === 'trending' || mode === 'gainers' || mode === 'new') && <div className='mx-4 p-2 text-xs text-genius-cream bg-red-500 bg-opacity-10 border-red-400 border-[1px] rounded-lg my-4'>
                  Tokens here are algorithmically sourced from on-chain data. They are not vetted
                  for honeypots or scams. Genius is not responsible for lost funds. Exercise caution
                  when trading.
                </div>}
              {stage === DefaultStages.loading && <div className='h-[80vh] w-full flex items-center flex-col justify-center'>
                  <Loading className=' h-8 w-8' />
                </div>}
              {stage === DefaultStages.results && <div className='h-full '>
                  <ScrollArea className={'h-[80vh] no-scrollbar'}>
                    {mode === 'search' && <p className='ml-4 text-2xl text-genius-cream '>Search Results</p>}
                    {mode === 'recent' && <p className='ml-4 text-2xl text-genius-cream '>Recent Items</p>}

                    {subMode === 'Trending' && mode === 'memes' && <>
                        {/* <div className='px-4 text-[12px] my-2  text-genius-cream p-4 border-red-400 border-[1px] rounded-[20px] bg-[#F8717126] mx-4'>
                          The Solana Blockchain is experiencing high congestion. Buys, sells and transfers may
                          not execute for Solana tokens.
                         </div> */}
                        <p className='text-[20px] text-genius-gradient ml-4 mb-2'>
                          Recently Listed
                        </p>

                        <div className='h-[20px] mb-[7vh]  '>
                          <NormeiTable resultsToUse={[resultsToUse()?.[0]]} setKeyword={setKeyword} timeFrame={timeFrame} className='h-full' tableRowClassName='h-full overflow-hidden ' />
                        </div>
                        <p className='text-[20px] text-genius-gradient ml-4 '>Trending</p>
                      </>}
                    {mode === 'top' && <p className='text-[20px] pl-4 py-3 gradient-genius-sides'>Top 10</p>}

                    {mode === 'top' || mode === 'native' ? <TopTokensResults mode={mode} resultsToUse={resultsToUse()} timeFrame={timeFrame} /> : <NormeiTable resultsToUse={resultsToUse()?.sort((a, b) => parseFloat(b?.['volume' + timeFrame]) - parseFloat(a?.['volume' + timeFrame]))} setKeyword={setKeyword} timeFrame={timeFrame} className='h-fit' scrollViewClassName='h-[44vh] ' />}

                    {allTokensLoading && <p className='text-genius-gradient text-[20px] pl-4 my-6'>
                        Loading All Tokens...
                      </p>}

                    {allTokens && mode == 'top' && <p className='text-[20px] pl-4 py-3 gradient-genius-sides'>All</p>}

                    {allTokens && mode == 'top' && <NormeiTable resultsToUse={allTokens} setKeyword={setKeyword} timeFrame={timeFrame} />}
                  </ScrollArea>
                </div>}
              {stage == DefaultStages.noResults && <div className='text-genius-cream/50 mx-auto justify-center ta-c text-base flex items-center mt-[150px] flex-col '>
                  <Image src='/static/icons/nothingcircle.png' width={100} height={100} alt='nothing here' className='w-[80px] w-[80px] my-8' />
                  {mode === 'search' ? 'No Safe Search Results' : mode === 'new' ? 'No New Tokens in the last 24 hours' : mode == 'saved' ? 'No Saved Tokens' : <div>
                      {' '}
                      <Loading />{' '}
                    </div>}
                  {mode === 'search' && !useUnprotectedSearch && <div className='bg-genius-blue rounded-full p-2 px-4 text-genius-cream mt-4 text-[12px]' onClick={() => {
              setUseUnprotectedSearch(true);
            }}>
                      Show Low Volume Results
                    </div>}
                </div>}
            </>}
        </div>
      </div>
    </div>;
};
export default NormeiController;